import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuListMUI from '@material-ui/core/MenuList';

// MUI's Menu component locks page scrolling when menu is opened
// This component is a modified version of a menu component from the docs that allows scrolling
// Documentation: https://mui.com/material-ui/react-menu/#menulist-composition

const MenuList = ({ anchorRef, handleClose, classes, children }) => {
  return (
    <Popper
      open={!!anchorRef}
      anchorEl={anchorRef}
      role={undefined}
      transition
      disablePortal
      placement="right"
      style={{ zIndex: 100 }}
      className={classes}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'right' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuListMUI>{children}</MenuListMUI>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default MenuList;
